module.exports = __webpack_public_path__ + "static/img/spxz.fa879da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spxz.jpg
// module id = xsa5
// module chunks = 4